module.exports = __webpack_public_path__ + "img/selected3-min.fd9feca7.png";